/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoTwitterIcon16Solid = forwardRef('LogoTwitterIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M12.762 3.648a1 1 0 1 0-1.524-1.296L8.44 5.645 5.91 2.298A.75.75 0 0 0 5.31 2H2.75a.75.75 0 0 0-.598 1.202L6.089 8.41l-3.35 3.942a1 1 0 0 0 1.523 1.296l3.063-3.604 2.766 3.658a.75.75 0 0 0 .598.298h2.561a.75.75 0 0 0 .598-1.202l-4.173-5.52 3.087-3.63Z" })));
});
